import React from 'react';
import { Award, Globe2, BadgeIndianRupee, ShieldCheck, Star, Users, Trophy, Headphones, MapPin, Sparkles } from 'lucide-react';
import { useSettings } from '../store';

const iconMap = {
  Award, Globe2, BadgeIndianRupee, ShieldCheck, Star, Users, Trophy, Headphones, MapPin, Sparkles,
};

const Benefits = () => {
  const settings = useSettings();
  const benefits = [
    { icon: settings.benefit_1_icon || 'Award', title: settings.benefit_1_title || '18+ years of Experience', desc: settings.benefit_1_desc || '', tone: 'blue' },
    { icon: settings.benefit_2_icon || 'Globe2', title: settings.benefit_2_title || '500+ Destinations', desc: settings.benefit_2_desc || '', tone: 'yellow' },
    { icon: settings.benefit_3_icon || 'BadgeIndianRupee', title: settings.benefit_3_title || 'Best Price In The Industry', desc: settings.benefit_3_desc || '', tone: 'blue' },
  ];

  return (
    <section className="bg-[#eef4f8] py-10">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-5">
        {benefits.map((b, idx) => {
          const Icon = iconMap[b.icon] || Award;
          const bg = b.tone === 'yellow' ? 'bg-[#fff8e1]' : 'bg-white';
          return (
            <div key={idx} className={`${bg} rounded-lg p-5 flex items-start gap-4 shadow-sm hover:shadow-md transition`}>
              <div className="w-14 h-14 rounded-full bg-[#0d64a8]/10 flex items-center justify-center text-[#0d64a8] shrink-0">
                <Icon size={26} />
              </div>
              <div>
                <h3 className="text-[17px] font-semibold text-gray-900 mb-1">{b.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{b.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Benefits;
